import { type ConsentType, type CustomerConsent, type hfb } from "@repo/api";
import {
  checkmarkCircleIcon,
  crossCircleIcon,
  questionMarkCircleIcon,
} from "@repo/skapa";
import { t } from "@repo/translation";
import isEmpty from "lodash/isEmpty";

export const getConsentValue = (
  consentType?: ConsentType,
  consents?: CustomerConsent[],
  departments?: hfb[],
  opportunityId?: number
) => {
  if (!consentType) {
    return undefined;
  }

  const consentList = consents?.filter((el) => el.consentType === consentType);

  if (opportunityId) {
    return consentList
      ?.sort((a, b) => {
        try {
          return a.updatedAt && b.updatedAt
            ? new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
            : 0;
        } catch {
          return 0;
        }
      })
      .find((el) => el.opportunityId === opportunityId);
  } else {
    return consentList?.find(
      (el) =>
        !el.opportunityId && el.hfb?.every((h) => departments?.includes(h))
    );
  }
};

export const isConsentApproved = (consent?: CustomerConsent) => {
  if (!consent) {
    return false;
  }
  if (consent.customerCommunicationSendStatus === "ERROR") {
    return false;
  }
  if (
    consent.consentProvided === undefined ||
    consent.consentProvided === false
  ) {
    return false;
  }
  return true;
};

export const isConsentValid = (
  consents?: CustomerConsent[],
  manualConsents?: CustomerConsent[],
  disableProjectCreationWithNoConsent?: boolean
) => {
  // if project creation is disabled, check if consent is approved
  if (disableProjectCreationWithNoConsent === true) {
    const followupConsent = consents?.find(
      (el) => el.consentType === "FOLLOWUP_CONSENT"
    );
    const manualFollowupConsent = manualConsents?.find(
      (el) => el.consentType === "FOLLOWUP_CONSENT"
    );

    if (
      !isConsentApproved(followupConsent) &&
      !isConsentApproved(manualFollowupConsent)
    ) {
      return false;
    }
  }
  // check if any consent is provided
  else if (isEmpty(consents) && isEmpty(manualConsents)) {
    return false;
  }

  return true;
};

export const getConsentDetails = (
  consent?: CustomerConsent,
  manualConsent?: boolean
) => {
  if (manualConsent !== undefined) {
    return {
      icon: manualConsent === true ? checkmarkCircleIcon : crossCircleIcon,
      text:
        manualConsent === true
          ? t("prompt.agreed_to_be_contacted")
          : t("prompt.do_not_contact"),
    };
  } else {
    if (!consent) {
      return {
        icon: questionMarkCircleIcon,
      };
    }
    if (consent.customerCommunicationSendStatus === "ERROR") {
      return {
        icon: crossCircleIcon,
        text: t("prompt.consent_error"),
      };
    }
    if (
      consent.consentId !== undefined &&
      consent.consentProvided === undefined
    ) {
      return {
        icon: questionMarkCircleIcon,
        text: t("prompt.consent_pending"),
      };
    }

    return {
      icon:
        consent.consentProvided === true
          ? checkmarkCircleIcon
          : crossCircleIcon,
      text:
        consent.consentProvided === true
          ? t("prompt.agreed_to_be_contacted")
          : t("prompt.do_not_contact"),
    };
  }
};
